/* NUT STORY — Did You Know Library | assets/dyk.js */
'use strict';

// ── CATEGORY FILTER ──────────────────────────────────────────────
function dykInitFilter() {
  const filter = document.querySelector('.dyk-filter');
  if (!filter) return;
  const pills = filter.querySelectorAll('.dyk-filter__pill');
  const cards = document.querySelectorAll('.dyk-card[data-category]');
  const countEl = document.querySelector('.dyk-grid__count');

  function setCount(n) {
    if (!countEl) return;
    countEl.textContent = n + ' ingredient' + (n !== 1 ? 's' : '');
  }

  function filterCards(category) {
    let visible = 0;
    cards.forEach(function(card) {
      const match = category === 'all' || card.dataset.category === category;
      card.hidden = !match;
      if (match) visible++;
    });
    setCount(visible);
  }

  pills.forEach(function(pill) {
    pill.addEventListener('click', function() {
      pills.forEach(function(p) { p.classList.remove('is-active'); p.setAttribute('aria-pressed', 'false'); });
      pill.classList.add('is-active');
      pill.setAttribute('aria-pressed', 'true');
      filterCards(pill.dataset.filter || 'all');
    });
  });

  // init count
  setCount(cards.length);
}

// ── SHARE BUTTON ──────────────────────────────────────────────────
function dykInitShare() {
  document.querySelectorAll('.dyk-share').forEach(function(widget) {
    const btn = widget.querySelector('.dyk-share__btn');
    const dropdown = widget.querySelector('.dyk-share__dropdown');
    if (!btn) return;

    const shareData = {
      title: widget.dataset.shareTitle || document.title,
      text: widget.dataset.shareText || '',
      url: widget.dataset.shareUrl || window.location.href
    };

    btn.addEventListener('click', function(e) {
      e.stopPropagation();
      // Try native Web Share API first (works on mobile / modern browsers)
      if (navigator.share && !dropdown) {
        navigator.share(shareData).catch(function() {});
        return;
      }
      if (navigator.share && dropdown && window.innerWidth < 768) {
        navigator.share(shareData).catch(function() {});
        return;
      }
      // Fallback: dropdown
      if (dropdown) {
        const isOpen = dropdown.classList.contains('is-open');
        // Close all other dropdowns
        document.querySelectorAll('.dyk-share__dropdown.is-open').forEach(function(d) {
          d.classList.remove('is-open');
        });
        if (!isOpen) dropdown.classList.add('is-open');
      }
    });

    // Share options
    if (dropdown) {
      dropdown.querySelectorAll('.dyk-share__option[data-platform]').forEach(function(opt) {
        opt.addEventListener('click', function() {
          const platform = opt.dataset.platform;
          const url = encodeURIComponent(shareData.url);
          const text = encodeURIComponent(shareData.title + ' ' + shareData.text);
          let href = '';
          if (platform === 'whatsapp') href = 'https://wa.me/?text=' + text + '%20' + url;
          else if (platform === 'facebook') href = 'https://www.facebook.com/sharer/sharer.php?u=' + url;
          else if (platform === 'twitter') href = 'https://twitter.com/intent/tweet?text=' + text + '&url=' + url;
          else if (platform === 'telegram') href = 'https://t.me/share/url?url=' + url + '&text=' + text;
          else if (platform === 'copy') {
            navigator.clipboard.writeText(shareData.url).then(function() {
              opt.textContent = 'Copied!';
              setTimeout(function() { opt.textContent = 'Copy Link'; }, 2000);
            });
            dropdown.classList.remove('is-open');
            return;
          }
          if (href) window.open(href, '_blank', 'noopener,noreferrer,width=600,height=400');
          dropdown.classList.remove('is-open');
        });
      });
    }
  });

  // Close dropdowns on outside click
  document.addEventListener('click', function() {
    document.querySelectorAll('.dyk-share__dropdown.is-open').forEach(function(d) {
      d.classList.remove('is-open');
    });
  });
}

// ── INIT ──────────────────────────────────────────────────────────
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', function() {
    dykInitFilter();
    dykInitShare();
  });
} else {
  dykInitFilter();
  dykInitShare();
}
